import React, { useEffect, useRef } from "react";

const InfiniteCarousel = ({ imageUrl }) => {
    const carouselRef = useRef(null);

    useEffect(() => {
        const carouselElement = carouselRef.current;
        if (!carouselElement) return;

        const animationDuration = 20;
        const animationName = "infiniteScroll";

        const keyframes = `@keyframes ${animationName} {
        0% { transform: translateX(0%); }
        100% { transform: translateX(-100%); }
      }`;

        const styleSheet = document.createElement("style");
        styleSheet.type = "text/css";
        styleSheet.innerText = keyframes;
        document.head.appendChild(styleSheet);
        carouselElement.style.animation = `${animationName} ${animationDuration}s linear infinite`;

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, [imageUrl]);

    return (
        <div className="carousel-container overflow-hidden">
            <div className="carousel flex" ref={carouselRef}>
                <img
                    src={imageUrl}
                    alt="Карусель"
                    className="carousel-image"
                    loading="eager"
                    decoding="async"
                />
                <img
                    src={imageUrl}
                    alt="Карусель (дублікат)"
                    className="carousel-image"
                    aria-hidden="true"
                    loading="eager"
                    decoding="async"
                />
            </div>
        </div>
    );
};

export default InfiniteCarousel;
